import React, { useId } from 'react';
import { MantineProvider } from '@mantine/core';
import { buildMantineTheme } from '../utils/buildMantineTheme';
import { googleFontHrefs, proposalFontFamilies } from '../utils/proposalStylesUtils';
import { extractProposalStyles } from '../../shared/theme/themeTypography';

/**
 * Le décor d'un aperçu du site hors de son canvas : thème Mantine, polices et
 * texte par défaut de `configuration`. Plusieurs aperçus cohabitent (document
 * et site côte à côte, tuiles d'une galerie) : chacun borne ses variables
 * Mantine à son propre conteneur.
 */
export default function SitePreviewScope({ configuration, theme, children }) {
  const scopeId = `element-preview-${useId().replace(/[^\w-]/g, '')}`;
  const textStyles = extractProposalStyles(configuration);

  return (
    <div id={scopeId}>
      <MantineProvider
        theme={buildMantineTheme({ ...theme, configuration })}
        cssVariablesSelector={`#${scopeId}`}
        withGlobalClasses={false}
      >
        {googleFontHrefs(proposalFontFamilies(textStyles)).map((href) => (
          <link key={href} rel="stylesheet" href={href} />
        ))}
        <div
          style={{
            fontFamily: textStyles.fontFamily ? `${textStyles.fontFamily}, sans-serif` : undefined,
            fontSize: textStyles.fontSize ? `${textStyles.fontSize}px` : undefined,
            color: textStyles.baseFontColor || undefined,
          }}
        >
          {children}
        </div>
      </MantineProvider>
    </div>
  );
}
